type AnalyticsFieldType =
  | 'analytics'
  | 'conversation_analytics'
  | 'pricing_analytics'
  | 'template_analytics'
  | 'template_group_analytics';

export interface AnalyticsMessagesData {
  start: number;
  end: number;
  granularity: string;
  fields: AnalyticsFieldType;
  filteringParameter?: Record<string, string | number | string[]>;
}

export interface AnalyticsTemplatesResponse {
  start: number;
  end: number;
  filteringParameter?: Record<string,  string[] | number[]>;
}


export enum ConversationCategoryEnum {
  AUTHENTICATION = 'AUTHENTICATION',
  MARKETING = 'MARKETING',
  SERVICE = 'SERVICE',
  UTILITY = 'UTILITY',
}

export enum ConversationTypeEnum {
  FREE_ENTRY = 'FREE_ENTRY',
  FREE_TIER = 'FREE_TIER',
  REGULAR = 'REGULAR',
}

export interface ConversationDataPoint {
  start: number;
  end: number;
  conversation: number;
  phone_number: string;
  country: string;
  conversation_type: ConversationTypeEnum;
  conversation_category: ConversationCategoryEnum;
  cost: number;
}

export interface ConversationAnalyticsData {
  data_points: ConversationDataPoint[];
}

export interface ConversationAnalyticsResponse {
  conversation_analytics: {
    data: ConversationAnalyticsData[];
  };
  id: string;
}

